module.exports = __webpack_public_path__ + "img/home_banner.fabe080d.jpg";